export default __webpack_public_path__ + "static/games-1d01c484d724400021d17aa72dba4ac2.png";